import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0d0d0f] shadow-lg' : 'bg-[#0d0d0f]'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 md:gap-4">
          <div className="w-16 h-16 md:w-28 md:h-28 flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/f6a69fc0db13ffc35ada9ab7bd949426/e71afb08991a347b1acfd62fa5c8c9d4.png"
              alt="Asher Reviews Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <h1 className="text-xl md:text-4xl font-black text-white tracking-tight">ASHER REVIEWS</h1>
            <p className="text-[10px] md:text-sm text-[#39ff14] font-bold uppercase tracking-wider">Real Gamer. Real Feedback.</p>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('why-me')}
            className="text-[#b8b8b8] hover:text-[#00f0ff] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
          >
            Why Me
          </button>
          <button
            onClick={() => scrollToSection('what-you-get')}
            className="text-[#b8b8b8] hover:text-[#00f0ff] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
          >
            What You Get
          </button>
          <button
            onClick={() => scrollToSection('pricing')}
            className="text-[#b8b8b8] hover:text-[#00f0ff] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
          >
            Pricing
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-[#b8b8b8] hover:text-[#00f0ff] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer"
          >
            Request Review
          </button>
        </nav>

        <button
          onClick={() => scrollToSection('contact')}
          className="hidden md:block px-8 py-3 bg-[#39ff14] text-[#0d0d0f] font-bold rounded-full hover:shadow-[0_0_20px_rgba(57,255,20,0.6)] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          style={{
            animation: 'pulse 2s infinite',
          }}
        >
          Get Started
        </button>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
        >
          <span className={`w-6 h-0.5 bg-[#39ff14] transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-[#39ff14] transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-[#39ff14] transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-[#0d0d0f] border-t border-[#39ff14]/20 transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col py-4">
          <button
            onClick={() => scrollToSection('why-me')}
            className="px-6 py-3 text-[#b8b8b8] hover:text-[#00f0ff] hover:bg-[#1a1a1c] transition-all duration-300 font-medium text-left cursor-pointer"
          >
            Why Me
          </button>
          <button
            onClick={() => scrollToSection('what-you-get')}
            className="px-6 py-3 text-[#b8b8b8] hover:text-[#00f0ff] hover:bg-[#1a1a1c] transition-all duration-300 font-medium text-left cursor-pointer"
          >
            What You Get
          </button>
          <button
            onClick={() => scrollToSection('pricing')}
            className="px-6 py-3 text-[#b8b8b8] hover:text-[#00f0ff] hover:bg-[#1a1a1c] transition-all duration-300 font-medium text-left cursor-pointer"
          >
            Pricing
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-3 text-[#b8b8b8] hover:text-[#00f0ff] hover:bg-[#1a1a1c] transition-all duration-300 font-medium text-left cursor-pointer"
          >
            Request Review
          </button>
          <div className="px-6 pt-2">
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full px-6 py-3 bg-[#39ff14] text-[#0d0d0f] font-bold rounded-full hover:shadow-[0_0_20px_rgba(57,255,20,0.6)] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
